/**
 * svc-lux-loyalty refuses reads of a Société account the customer can no longer use, and says why
 * in `errorCode`. Match on the code, not the HTTP status: the service also uses 409 for unrelated
 * conflicts.
 */
const LOYALTY_ACCOUNT_CLOSED_ERROR_CODES = [
  // Closed by an admin
  'ACCOUNT_CLOSED',
  // The IBS membership was closed in iLoyal
  'ACCOUNT_MEMBERSHIP_CLOSED',
  // The account exists but has no IBS member, so it can neither be used nor created again
  'ACCOUNT_IBS_MEMBER_NOT_FOUND',
] as const

export type LoyaltyAccountClosedErrorCode = typeof LOYALTY_ACCOUNT_CLOSED_ERROR_CODES[number]

function isLoyaltyAccountClosedErrorCode(code: unknown): code is LoyaltyAccountClosedErrorCode {
  return LOYALTY_ACCOUNT_CLOSED_ERROR_CODES.some(closedCode => closedCode === code)
}

function getLoyaltyAccountClosedErrorCode(error: unknown): LoyaltyAccountClosedErrorCode | undefined {
  if (typeof error !== 'object' || error === null || !('errorCode' in error)) {
    return undefined
  }
  return isLoyaltyAccountClosedErrorCode(error.errorCode) ? error.errorCode : undefined
}

export default getLoyaltyAccountClosedErrorCode
